export interface HandleOption{
    id: number,
    type: string,
    colorCategory: string | null,
    label: string,
}

export interface KeyChoiceOption{
  id: number,
    type: string,
    label: string,
}

const handleColors = [
  { label: "Rustic Umber", img: "Handles/colors/Rustic_Umber" },
  {
    label: "Satin Nickel(Resista Finish)",
    img: "Handles/colors/Satin_Nickle",
  },
  { label: "Matte Black", img: "Handles/colors/Matte_Black" },
  { label: "White", img: "Handles/colors/White" },
  { label: "Oil Rubbed Bronze *", img: "Handles/colors/Oil_Rubbed_Bronze" },
  { label: "Oil Rubbed Bronze", img: "Handles/colors/Oil_Rubbed_Bronze" },
  { label: "Polished Brass", img: "Handles/colors/Polished_Brass" },
  { label: "Satin PVD", img: "Handles/colors/Satin_PVD" },
  { label: "Satin Nickel PVD", img: "Handles/colors/Satin_PVD" },
  { label: "Bronze PVD", img: "Handles/colors/Bronze_PVD" },
  { label: "Satin Brass", img: "Handles/colors/emtek/Satin_Brass" },
  { label: "Polished Nickel", img: "Handles/colors/emtek/Polished_Nickel" },
  { label: "Flat Black", img: "Handles/colors/Matte_Black" },
  { label: "Polished Chrome", img: "Handles/colors/emtek/Polished_Chrome" },
  {
    label: "Alpine Frost",
    img: "Handles/colors/Satin_Nickle",
  },
];

const normalHandleColor = [
  "Rustic Umber",
  "Satin Nickel(Resista Finish)",
  "Matte Black",
  "White",
  "Oil Rubbed Bronze *",
]; //white is verona only

const veronaSliderColor = [
  "Rustic Umber",
  "Satin Nickel(Resista Finish)",
  "Matte Black",
  "White",
  "Polished Brass",
  "Oil Rubbed Bronze *",
];

const sliderTruthMountColors = [
  "Satin Nickel PVD",
  "Bronze PVD",
  "Matte Black",
];

const normalHandleColorDallas = [
  "Rustic Umber",
  "Satin Nickel(Resista Finish)",
  "Matte Black",
];

const emtekColors = [
  "Satin Brass",
  "Oil Rubbed Bronze",
  "Polished Nickel",
  "Satin Nickel(Resista Finish)",
  "Flat Black",
  "Polished Chrome",
]

const emtekColorsNouvel = [
  ...emtekColors,
  "Brushed Stainless Steel"
]

const handleColorPico = [
  "Matte Black",
  "Rustic Umber",
  "Alpine Frost"
];

const special = ["Matte Black", "Satin Nickel(Resista Finish)", "Rustic Umber"];

const specialAtlanta = ["Matte Black", "Satin Nickel(Resista Finish)"];

const handleImages = [
  { label: "Verona", imgLabel: "Handles/verona", colorCategory: "standard" },
  { label: "Dallas", imgLabel: "Handles/dallas", colorCategory: "standard" },
  { label: "Atlanta *", imgLabel: "Handles/atlanta", colorCategory: "special atlanta" },
  { label: "Rodos *", imgLabel: "Handles/rodos", colorCategory: "special" },
  { label: "Munchen *", imgLabel: "Handles/munchen", colorCategory: "special" },
  { label: "New Orleans *", imgLabel: "Handles/neworleans", colorCategory: "special" },
  { label: "Toronto *", imgLabel: "Handles/toronto", colorCategory: "special" },
  { label: "Nouvel *", imgLabel: "Handles/Nouvel_v5", colorCategory: "emtek nouvel" },
  { label: "Franklin", imgLabel: "Handles/franklin_nofinish", colorCategory: "emtek" },
  { label: "Hamden", imgLabel: "Handles/hamden_nofinish", colorCategory: "emtek" },
  { label: "Baden", imgLabel: "Handles/baden_nofinish", colorCategory: "emtek" },
  { label: "Ares", imgLabel: "Handles/ares_nofinish", colorCategory: "emtek" },
  { label: "Hercules Smooth", imgLabel: "Handles/hercules_smooth_nofinish", colorCategory: "emtek" },
  { label: "Hercules Knurled", imgLabel: "Handles/hercules_knurled_nofinish", colorCategory: "emtek" },
  { label: "Toulon", imgLabel: "Handles/toulon" },
  { label: "Savannah", imgLabel: "Handles/savannah" },
];

const sliderImgs = [
  { label: "Verona", imgLabel: "Handles/VeronaSlider" },
  { label: "Dallas", imgLabel: "Handles/dallasSlider" },
  { label: "One Piece Truth (Flush Mount)", imgLabel: "Handles/TruthFlush" },
];

const withHandle = [
  {
    id: 1,
    type: "withHandle",
    label: "Add Handle Set",
  },
  {
    id: 2,
    type: "withHandle",
    label: "No Handle Set",
  },
];

const secondaryHandle = [
  {
    id: 1,
    type: "secondaryHandle",
    label: "No Handle",
  },
  {
    id: 2,
    type: "secondaryHandle",
    label: "Matching Dummy Handle",
  },
];

const handlesPico: HandleOption[] = [
  {
    id: 1,
    type: "handleStyle",
    colorCategory: null,
    label: "Savannah",
  },
  {
    id: 2,
    type: "handleStyle",
    colorCategory: null,
    label: "Toulon",
  },
];

const handles: HandleOption[] = [
  {
    id: 1,
    type: "handleStyle",
    colorCategory: "standard",
    label: "Verona",
  },
  {
    id: 2,
    type: "handleStyle",
    colorCategory: "standard",
    label: "Dallas",
  },
  {
    id: 3,
    type: "handleStyle",
    colorCategory: null,
    label: "Savannah",
  },
  {
    id: 4,
    type: "handleStyle",
    colorCategory: null,
    label: "Toulon",
  },
];

const nonPocketHandles: HandleOption[] = [
  {
    id: 1,
    type: "handleStyle",
    colorCategory: "standard",
    label: "Verona",
  },
  {
    id: 2,
    type: "handleStyle",
    colorCategory: "standard",
    label: "Dallas",
  },
  {
    id: 3,
    type: "handleStyle",
    colorCategory: "truth",
    label: "One Piece Truth (Flush Mount)",
  },
];

const specialOrder: HandleOption[] = [
  {
    id: 1,
    type: "handleStyle",
    colorCategory: "special",
    label: "Atlanta *",
  },
  {
    id: 2,
    type: "handleStyle",
    colorCategory: "special",
    label: "Rodos *",
  },
  {
    id: 3,
    type: "handleStyle",
    colorCategory: "special",
    label: "Munchen *",
  },
  {
    id: 4,
    type: "handleStyle",
    colorCategory: "special",
    label: "New Orleans *",
  },
  {
    id: 5,
    type: "handleStyle",
    colorCategory: "special",
    label: "Toronto *",
  },
  {
    id: 6,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Nouvel *",
  },
  {
    id: 7,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Smart Lock *",
  },
];

const bluetoothHandles: HandleOption[] = [
  {
    id: 1,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Hercules Smooth",
  },
  {
    id: 2,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Hercules Knurled",
  },
  {
    id: 3,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Baden",
  },
  {
    id: 4,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Ares",
  },
  {
    id: 5,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Franklin",
  },
  {
    id: 6,
    type: "handleStyle",
    colorCategory: "emtek",
    label: "Hamden",
  },
];

const withKey = [
  {
    id: 1,
    type: "withKey",
    label: "Exterior Key",
  },
  {
    id: 2,
    type: "withKey",
    label: "No Key",
  },
];

export {
  withKey,
  specialOrder,
  bluetoothHandles,
  nonPocketHandles,
  handles,
  withHandle,
  secondaryHandle,
  sliderImgs,
  handleImages,
  specialAtlanta,
  special,
  normalHandleColorDallas,
  sliderTruthMountColors,
  veronaSliderColor,
  normalHandleColor,
  handleColors,
  emtekColors,
  emtekColorsNouvel,
  handlesPico,
  handleColorPico
};
